import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import freeEvent from "../../assets/images/events/free-event.svg";
import paidEvent from "../../assets/images/events/paid-event.svg";
import adHocEvent from "../../assets/images/events/ad-hoc-event.svg";
import FeatureLock from "../../components/FeatureLock/FeatureLock";
import PlanLimitLock from "../../components/PlanLimitLock/PlanLimitLock";
import { FEATURE_IDS } from "../../constants/featureAccess";
import { PLAN_LIMIT_TYPES } from "../../utils/planLimits";
import { fetchAccountSetupComplete } from "../../utils/accountSetup";
import { requestQuickSetupPulse } from "../../utils/quickSetupPulse";

const FREE_EVENT_HREF = "/admin/events/create?type=free-event";
const PAID_EVENT_HREF = "/admin/events/create?type=paid-event";

const EventTypeList = () => {
  const navigate = useNavigate();
  const [setupComplete, setSetupComplete] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetchAccountSetupComplete().then((complete) => {
      if (!cancelled) {
        setSetupComplete(complete);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const onGuardedCreateClick = useCallback(
    (event, href) => {
      if (setupComplete === true) {
        return;
      }

      event.preventDefault();

      if (setupComplete === false) {
        requestQuickSetupPulse();
        return;
      }

      fetchAccountSetupComplete().then((complete) => {
        setSetupComplete(complete);
        if (complete) {
          navigate(href);
          return;
        }
        requestQuickSetupPulse();
      });
    },
    [navigate, setupComplete]
  );

  return (
    <div className="event-wrapper">
      <div className="event-container">
        <h2 className="event-title">Create New Events</h2>
        <div className="event-type-wrapper">
          <div className="row justify-content-center">
            <div className="col-md-6 col-xl-3">
              <PlanLimitLock limitType={PLAN_LIMIT_TYPES.EVENTS}>
                <Link
                  to={FREE_EVENT_HREF}
                  onClick={(event) =>
                    onGuardedCreateClick(event, FREE_EVENT_HREF)
                  }
                >
                  <div className="card">
                    <div className="image-wrapper">
                      <img src={freeEvent} alt="Free Event" />
                    </div>
                    <p>I want to create a free event</p>
                  </div>
                </Link>
              </PlanLimitLock>
            </div>
            <div className="col-md-6 col-xl-3">
              <PlanLimitLock limitType={PLAN_LIMIT_TYPES.EVENTS}>
                <FeatureLock featureId={FEATURE_IDS.COLLECT_PAYMENTS}>
                  <Link
                    to={PAID_EVENT_HREF}
                    onClick={(event) =>
                      onGuardedCreateClick(event, PAID_EVENT_HREF)
                    }
                  >
                    <div className="card">
                      <div className="image-wrapper">
                        <img src={paidEvent} alt="Paid Event" />
                      </div>
                      <p>I want to charge for the event</p>
                    </div>
                  </Link>
                </FeatureLock>
              </PlanLimitLock>
            </div>
            <div className="col-md-6 col-xl-3">
              <PlanLimitLock limitType={PLAN_LIMIT_TYPES.EVENTS}>
                <Link to="/admin/events/create/ad-hoc">
                  <div className="card">
                    <div className="image-wrapper">
                      <img src={adHocEvent} alt="Ad Hoc Event" />
                    </div>
                    <p>I want to start a quick event</p>
                  </div>
                </Link>
              </PlanLimitLock>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventTypeList;
